import PropTypes from 'prop-types';
import { action, extendObservable } from 'mobx';
import { PolicyModalSectionProps } from './PolicyModalStore';
import FuseSelectStore from '../FuseSelectStore';
import FlagStore from '../FlagStore';

export const SOURCE_COUNTRY_OPTIONS = [
    { value: 'ad', label: 'Andorra', textIcon: '🇦🇩' },
    { value: 'ae', label: 'United Arab Emirates', textIcon: '🇦🇪' },
    { value: 'af', label: 'Afghanistan', textIcon: '🇦🇫' },
    { value: 'ag', label: 'Antigua and Barbuda', textIcon: '🇦🇬' },
    { value: 'ai', label: 'Anguilla', textIcon: '🇦🇮' },
    { value: 'al', label: 'Albania', textIcon: '🇦🇱' },
    { value: 'am', label: 'Armenia', textIcon: '🇦🇲' },
    { value: 'ao', label: 'Angola', textIcon: '🇦🇴' },
    { value: 'aq', label: 'Antarctica', textIcon: '🇦🇶' },
    { value: 'ar', label: 'Argentina', textIcon: '🇦🇷' },
    { value: 'as', label: 'American Samoa', textIcon: '🇦🇸' },
    { value: 'at', label: 'Austria', textIcon: '🇦🇹' },
    { value: 'au', label: 'Australia', textIcon: '🇦🇺' },
    { value: 'aw', label: 'Aruba', textIcon: '🇦🇼' },
    { value: 'ax', label: 'Åland Islands', textIcon: '🇦🇽' },
    { value: 'az', label: 'Azerbaijan', textIcon: '🇦🇿' },
    { value: 'ba', label: 'Bosnia and Herzegovina', textIcon: '🇧🇦' },
    { value: 'bb', label: 'Barbados', textIcon: '🇧🇧' },
    { value: 'bd', label: 'Bangladesh', textIcon: '🇧🇩' },
    { value: 'be', label: 'Belgium', textIcon: '🇧🇪' },
    { value: 'bf', label: 'Burkina Faso', textIcon: '🇧🇫' },
    { value: 'bg', label: 'Bulgaria', textIcon: '🇧🇬' },
    { value: 'bh', label: 'Bahrain', textIcon: '🇧🇭' },
    { value: 'bi', label: 'Burundi', textIcon: '🇧🇮' },
    { value: 'bj', label: 'Benin', textIcon: '🇧🇯' },
    { value: 'bl', label: 'Saint Barthélemy', textIcon: '🇧🇱' },
    { value: 'bm', label: 'Bermuda', textIcon: '🇧🇲' },
    { value: 'bn', label: 'Brunei Darussalam', textIcon: '🇧🇳' },
    { value: 'bo', label: 'Bolivia', textIcon: '🇧🇴' },
    { value: 'bq', label: 'Bonaire, Sint Eustatius and Saba', textIcon: '🇧🇶' },
    { value: 'br', label: 'Brazil', textIcon: '🇧🇷' },
    { value: 'bs', label: 'Bahamas', textIcon: '🇧🇸' },
    { value: 'bt', label: 'Bhutan', textIcon: '🇧🇹' },
    { value: 'bv', label: 'Bouvet Island', textIcon: '🇧🇻' },
    { value: 'bw', label: 'Botswana', textIcon: '🇧🇼' },
    { value: 'by', label: 'Belarus', textIcon: '🇧🇾' },
    { value: 'bz', label: 'Belize', textIcon: '🇧🇿' },
    { value: 'ca', label: 'Canada', textIcon: '🇨🇦' },
    { value: 'cc', label: 'Cocos (Keeling) Islands', textIcon: '🇨🇨' },
    { value: 'cd', label: 'Congo', textIcon: '🇨🇩' },
    { value: 'cf', label: 'Central African Republic', textIcon: '🇨🇫' },
    { value: 'cg', label: 'Congo', textIcon: '🇨🇬' },
    { value: 'ch', label: 'Switzerland', textIcon: '🇨🇭' },
    { value: 'ci', label: 'Côte D\'Ivoire', textIcon: '🇨🇮' },
    { value: 'ck', label: 'Cook Islands', textIcon: '🇨🇰' },
    { value: 'cl', label: 'Chile', textIcon: '🇨🇱' },
    { value: 'cm', label: 'Cameroon', textIcon: '🇨🇲' },
    { value: 'cn', label: 'China', textIcon: '🇨🇳' },
    { value: 'co', label: 'Colombia', textIcon: '🇨🇴' },
    { value: 'cr', label: 'Costa Rica', textIcon: '🇨🇷' },
    { value: 'cu', label: 'Cuba', textIcon: '🇨🇺' },
    { value: 'cv', label: 'Cape Verde', textIcon: '🇨🇻' },
    { value: 'cw', label: 'Curaçao', textIcon: '🇨🇼' },
    { value: 'cx', label: 'Christmas Island', textIcon: '🇨🇽' },
    { value: 'cy', label: 'Cyprus', textIcon: '🇨🇾' },
    { value: 'cz', label: 'Czech Republic', textIcon: '🇨🇿' },
    { value: 'de', label: 'Germany', textIcon: '🇩🇪' },
    { value: 'dj', label: 'Djibouti', textIcon: '🇩🇯' },
    { value: 'dk', label: 'Denmark', textIcon: '🇩🇰' },
    { value: 'dm', label: 'Dominica', textIcon: '🇩🇲' },
    { value: 'do', label: 'Dominican Republic', textIcon: '🇩🇴' },
    { value: 'dz', label: 'Algeria', textIcon: '🇩🇿' },
    { value: 'ec', label: 'Ecuador', textIcon: '🇪🇨' },
    { value: 'ee', label: 'Estonia', textIcon: '🇪🇪' },
    { value: 'eg', label: 'Egypt', textIcon: '🇪🇬' },
    { value: 'eh', label: 'Western Sahara', textIcon: '🇪🇭' },
    { value: 'er', label: 'Eritrea', textIcon: '🇪🇷' },
    { value: 'es', label: 'Spain', textIcon: '🇪🇸' },
    { value: 'et', label: 'Ethiopia', textIcon: '🇪🇹' },
    { value: 'fi', label: 'Finland', textIcon: '🇫🇮' },
    { value: 'fj', label: 'Fiji', textIcon: '🇫🇯' },
    { value: 'fk', label: 'Falkland Islands (Malvinas)', textIcon: '🇫🇰' },
    { value: 'fm', label: 'Micronesia', textIcon: '🇫🇲' },
    { value: 'fo', label: 'Faroe Islands', textIcon: '🇫🇴' },
    { value: 'fr', label: 'France', textIcon: '🇫🇷' },
    { value: 'ga', label: 'Gabon', textIcon: '🇬🇦' },
    { value: 'gb', label: 'United Kingdom', textIcon: '🇬🇧' },
    { value: 'gd', label: 'Grenada', textIcon: '🇬🇩' },
    { value: 'ge', label: 'Georgia', textIcon: '🇬🇪' },
    { value: 'gf', label: 'French Guiana', textIcon: '🇬🇫' },
    { value: 'gg', label: 'Guernsey', textIcon: '🇬🇬' },
    { value: 'gh', label: 'Ghana', textIcon: '🇬🇭' },
    { value: 'gi', label: 'Gibraltar', textIcon: '🇬🇮' },
    { value: 'gl', label: 'Greenland', textIcon: '🇬🇱' },
    { value: 'gm', label: 'Gambia', textIcon: '🇬🇲' },
    { value: 'gn', label: 'Guinea', textIcon: '🇬🇳' },
    { value: 'gp', label: 'Guadeloupe', textIcon: '🇬🇵' },
    { value: 'gq', label: 'Equatorial Guinea', textIcon: '🇬🇶' },
    { value: 'gr', label: 'Greece', textIcon: '🇬🇷' },
    { value: 'gs', label: 'South Georgia', textIcon: '🇬🇸' },
    { value: 'gt', label: 'Guatemala', textIcon: '🇬🇹' },
    { value: 'gu', label: 'Guam', textIcon: '🇬🇺' },
    { value: 'gw', label: 'Guinea-Bissau', textIcon: '🇬🇼' },
    { value: 'gy', label: 'Guyana', textIcon: '🇬🇾' },
    { value: 'hk', label: 'Hong Kong', textIcon: '🇭🇰' },
    { value: 'hm', label: 'Heard Island and Mcdonald Islands', textIcon: '🇭🇲' },
    { value: 'hn', label: 'Honduras', textIcon: '🇭🇳' },
    { value: 'hr', label: 'Croatia', textIcon: '🇭🇷' },
    { value: 'ht', label: 'Haiti', textIcon: '🇭🇹' },
    { value: 'hu', label: 'Hungary', textIcon: '🇭🇺' },
    { value: 'id', label: 'Indonesia', textIcon: '🇮🇩' },
    { value: 'ie', label: 'Ireland', textIcon: '🇮🇪' },
    { value: 'il', label: 'Israel', textIcon: '🇮🇱' },
    { value: 'im', label: 'Isle of Man', textIcon: '🇮🇲' },
    { value: 'in', label: 'India', textIcon: '🇮🇳' },
    { value: 'io', label: 'British Indian Ocean Territory', textIcon: '🇮🇴' },
    { value: 'iq', label: 'Iraq', textIcon: '🇮🇶' },
    { value: 'ir', label: 'Iran', textIcon: '🇮🇷' },
    { value: 'is', label: 'Iceland', textIcon: '🇮🇸' },
    { value: 'it', label: 'Italy', textIcon: '🇮🇹' },
    { value: 'je', label: 'Jersey', textIcon: '🇯🇪' },
    { value: 'jm', label: 'Jamaica', textIcon: '🇯🇲' },
    { value: 'jo', label: 'Jordan', textIcon: '🇯🇴' },
    { value: 'jp', label: 'Japan', textIcon: '🇯🇵' },
    { value: 'ke', label: 'Kenya', textIcon: '🇰🇪' },
    { value: 'kg', label: 'Kyrgyzstan', textIcon: '🇰🇬' },
    { value: 'kh', label: 'Cambodia', textIcon: '🇰🇭' },
    { value: 'ki', label: 'Kiribati', textIcon: '🇰🇮' },
    { value: 'km', label: 'Comoros', textIcon: '🇰🇲' },
    { value: 'kn', label: 'Saint Kitts and Nevis', textIcon: '🇰🇳' },
    { value: 'kp', label: 'North Korea', textIcon: '🇰🇵' },
    { value: 'kr', label: 'South Korea', textIcon: '🇰🇷' },
    { value: 'kw', label: 'Kuwait', textIcon: '🇰🇼' },
    { value: 'ky', label: 'Cayman Islands', textIcon: '🇰🇾' },
    { value: 'kz', label: 'Kazakhstan', textIcon: '🇰🇿' },
    { value: 'la', label: 'Lao People\'s Democratic Republic', textIcon: '🇱🇦' },
    { value: 'lb', label: 'Lebanon', textIcon: '🇱🇧' },
    { value: 'lc', label: 'Saint Lucia', textIcon: '🇱🇨' },
    { value: 'li', label: 'Liechtenstein', textIcon: '🇱🇮' },
    { value: 'lk', label: 'Sri Lanka', textIcon: '🇱🇰' },
    { value: 'lr', label: 'Liberia', textIcon: '🇱🇷' },
    { value: 'ls', label: 'Lesotho', textIcon: '🇱🇸' },
    { value: 'lt', label: 'Lithuania', textIcon: '🇱🇹' },
    { value: 'lu', label: 'Luxembourg', textIcon: '🇱🇺' },
    { value: 'lv', label: 'Latvia', textIcon: '🇱🇻' },
    { value: 'ly', label: 'Libya', textIcon: '🇱🇾' },
    { value: 'ma', label: 'Morocco', textIcon: '🇲🇦' },
    { value: 'mc', label: 'Monaco', textIcon: '🇲🇨' },
    { value: 'md', label: 'Moldova', textIcon: '🇲🇩' },
    { value: 'me', label: 'Montenegro', textIcon: '🇲🇪' },
    { value: 'mf', label: 'Saint Martin (French Part)', textIcon: '🇲🇫' },
    { value: 'mg', label: 'Madagascar', textIcon: '🇲🇬' },
    { value: 'mh', label: 'Marshall Islands', textIcon: '🇲🇭' },
    { value: 'mk', label: 'Macedonia', textIcon: '🇲🇰' },
    { value: 'ml', label: 'Mali', textIcon: '🇲🇱' },
    { value: 'mm', label: 'Myanmar', textIcon: '🇲🇲' },
    { value: 'mn', label: 'Mongolia', textIcon: '🇲🇳' },
    { value: 'mo', label: 'Macao', textIcon: '🇲🇴' },
    { value: 'mp', label: 'Northern Mariana Islands', textIcon: '🇲🇵' },
    { value: 'mq', label: 'Martinique', textIcon: '🇲🇶' },
    { value: 'mr', label: 'Mauritania', textIcon: '🇲🇷' },
    { value: 'ms', label: 'Montserrat', textIcon: '🇲🇸' },
    { value: 'mt', label: 'Malta', textIcon: '🇲🇹' },
    { value: 'mu', label: 'Mauritius', textIcon: '🇲🇺' },
    { value: 'mv', label: 'Maldives', textIcon: '🇲🇻' },
    { value: 'mw', label: 'Malawi', textIcon: '🇲🇼' },
    { value: 'mx', label: 'Mexico', textIcon: '🇲🇽' },
    { value: 'my', label: 'Malaysia', textIcon: '🇲🇾' },
    { value: 'mz', label: 'Mozambique', textIcon: '🇲🇿' },
    { value: 'na', label: 'Namibia', textIcon: '🇳🇦' },
    { value: 'nc', label: 'New Caledonia', textIcon: '🇳🇨' },
    { value: 'ne', label: 'Niger', textIcon: '🇳🇪' },
    { value: 'nf', label: 'Norfolk Island', textIcon: '🇳🇫' },
    { value: 'ng', label: 'Nigeria', textIcon: '🇳🇬' },
    { value: 'ni', label: 'Nicaragua', textIcon: '🇳🇮' },
    { value: 'nl', label: 'Netherlands', textIcon: '🇳🇱' },
    { value: 'no', label: 'Norway', textIcon: '🇳🇴' },
    { value: 'np', label: 'Nepal', textIcon: '🇳🇵' },
    { value: 'nr', label: 'Nauru', textIcon: '🇳🇷' },
    { value: 'nu', label: 'Niue', textIcon: '🇳🇺' },
    { value: 'nz', label: 'New Zealand', textIcon: '🇳🇿' },
    { value: 'om', label: 'Oman', textIcon: '🇴🇲' },
    { value: 'pa', label: 'Panama', textIcon: '🇵🇦' },
    { value: 'pe', label: 'Peru', textIcon: '🇵🇪' },
    { value: 'pf', label: 'French Polynesia', textIcon: '🇵🇫' },
    { value: 'pg', label: 'Papua New Guinea', textIcon: '🇵🇬' },
    { value: 'ph', label: 'Philippines', textIcon: '🇵🇭' },
    { value: 'pk', label: 'Pakistan', textIcon: '🇵🇰' },
    { value: 'pl', label: 'Poland', textIcon: '🇵🇱' },
    { value: 'pm', label: 'Saint Pierre and Miquelon', textIcon: '🇵🇲' },
    { value: 'pn', label: 'Pitcairn', textIcon: '🇵🇳' },
    { value: 'pr', label: 'Puerto Rico', textIcon: '🇵🇷' },
    { value: 'ps', label: 'Palestinian Territory', textIcon: '🇵🇸' },
    { value: 'pt', label: 'Portugal', textIcon: '🇵🇹' },
    { value: 'pw', label: 'Palau', textIcon: '🇵🇼' },
    { value: 'py', label: 'Paraguay', textIcon: '🇵🇾' },
    { value: 'qa', label: 'Qatar', textIcon: '🇶🇦' },
    { value: 're', label: 'Réunion', textIcon: '🇷🇪' },
    { value: 'ro', label: 'Romania', textIcon: '🇷🇴' },
    { value: 'rs', label: 'Serbia', textIcon: '🇷🇸' },
    { value: 'ru', label: 'Russia', textIcon: '🇷🇺' },
    { value: 'rw', label: 'Rwanda', textIcon: '🇷🇼' },
    { value: 'sa', label: 'Saudi Arabia', textIcon: '🇸🇦' },
    { value: 'sb', label: 'Solomon Islands', textIcon: '🇸🇧' },
    { value: 'sc', label: 'Seychelles', textIcon: '🇸🇨' },
    { value: 'sd', label: 'Sudan', textIcon: '🇸🇩' },
    { value: 'se', label: 'Sweden', textIcon: '🇸🇪' },
    { value: 'sg', label: 'Singapore', textIcon: '🇸🇬' },
    { value: 'sh', label: 'Saint Helena, Ascension and Tristan Da Cunha', textIcon: '🇸🇭' },
    { value: 'si', label: 'Slovenia', textIcon: '🇸🇮' },
    { value: 'sj', label: 'Svalbard and Jan Mayen', textIcon: '🇸🇯' },
    { value: 'sk', label: 'Slovakia', textIcon: '🇸🇰' },
    { value: 'sl', label: 'Sierra Leone', textIcon: '🇸🇱' },
    { value: 'sm', label: 'San Marino', textIcon: '🇸🇲' },
    { value: 'sn', label: 'Senegal', textIcon: '🇸🇳' },
    { value: 'so', label: 'Somalia', textIcon: '🇸🇴' },
    { value: 'sr', label: 'Suriname', textIcon: '🇸🇷' },
    { value: 'ss', label: 'South Sudan', textIcon: '🇸🇸' },
    { value: 'st', label: 'Sao Tome and Principe', textIcon: '🇸🇹' },
    { value: 'sv', label: 'El Salvador', textIcon: '🇸🇻' },
    { value: 'sx', label: 'Sint Maarten (Dutch Part)', textIcon: '🇸🇽' },
    { value: 'sy', label: 'Syrian Arab Republic', textIcon: '🇸🇾' },
    { value: 'sz', label: 'Swaziland', textIcon: '🇸🇿' },
    { value: 'tc', label: 'Turks and Caicos Islands', textIcon: '🇹🇨' },
    { value: 'td', label: 'Chad', textIcon: '🇹🇩' },
    { value: 'tf', label: 'French Southern Territories', textIcon: '🇹🇫' },
    { value: 'tg', label: 'Togo', textIcon: '🇹🇬' },
    { value: 'th', label: 'Thailand', textIcon: '🇹🇭' },
    { value: 'tj', label: 'Tajikistan', textIcon: '🇹🇯' },
    { value: 'tk', label: 'Tokelau', textIcon: '🇹🇰' },
    { value: 'tl', label: 'Timor-Leste', textIcon: '🇹🇱' },
    { value: 'tm', label: 'Turkmenistan', textIcon: '🇹🇲' },
    { value: 'tn', label: 'Tunisia', textIcon: '🇹🇳' },
    { value: 'to', label: 'Tonga', textIcon: '🇹🇴' },
    { value: 'tr', label: 'Turkey', textIcon: '🇹🇷' },
    { value: 'tt', label: 'Trinidad and Tobago', textIcon: '🇹🇹' },
    { value: 'tv', label: 'Tuvalu', textIcon: '🇹🇻' },
    { value: 'tw', label: 'Taiwan', textIcon: '🇹🇼' },
    { value: 'tz', label: 'Tanzania', textIcon: '🇹🇿' },
    { value: 'ua', label: 'Ukraine', textIcon: '🇺🇦' },
    { value: 'ug', label: 'Uganda', textIcon: '🇺🇬' },
    { value: 'um', label: 'United States Minor Outlying Islands', textIcon: '🇺🇲' },
    { value: 'us', label: 'United States', textIcon: '🇺🇸' },
    { value: 'uy', label: 'Uruguay', textIcon: '🇺🇾' },
    { value: 'uz', label: 'Uzbekistan', textIcon: '🇺🇿' },
    { value: 'va', label: 'Vatican City', textIcon: '🇻🇦' },
    { value: 'vc', label: 'Saint Vincent and The Grenadines', textIcon: '🇻🇨' },
    { value: 've', label: 'Venezuela', textIcon: '🇻🇪' },
    { value: 'vg', label: 'Virgin Islands, British', textIcon: '🇻🇬' },
    { value: 'vi', label: 'Virgin Islands, U.S.', textIcon: '🇻🇮' },
    { value: 'vn', label: 'Viet Nam', textIcon: '🇻🇳' },
    { value: 'vu', label: 'Vanuatu', textIcon: '🇻🇺' },
    { value: 'wf', label: 'Wallis and Futuna', textIcon: '🇼🇫' },
    { value: 'ws', label: 'Samoa', textIcon: '🇼🇸' },
    { value: 'ye', label: 'Yemen', textIcon: '🇾🇪' },
    { value: 'yt', label: 'Mayotte', textIcon: '🇾🇹' },
    { value: 'za', label: 'South Africa', textIcon: '🇿🇦' },
    { value: 'zm', label: 'Zambia', textIcon: '🇿🇲' },
    { value: 'zw', label: 'Zimbabwe', textIcon: '🇿🇼' }
];


const DEFAULT_VALUES = {
    matchAllCountries: false,
    matchCountries: { items: [] },
};

export default class SourceCountriesStore {
    static getLabelByAbbreviation = (abbr) =>
        SOURCE_COUNTRY_OPTIONS.find((c) => c.value === abbr)?.label
    static PropType = PropTypes.shape({
        sourceCountriesSelect: FuseSelectStore.PropType.isRequired,
        matchAllCountries: FlagStore.PropType.isRequired,

        ...PolicyModalSectionProps,
    });

    constructor(data = {}) {
        const sourceCountryOptions = SOURCE_COUNTRY_OPTIONS
            .sort((country1, country2) => country1.label.localeCompare(country2.label));
        extendObservable(this, /** @class SourceCountriesStore */{
            sourceCountriesSelect: new FuseSelectStore({ options: sourceCountryOptions }),
            matchAllCountries: new FlagStore(),

            originalValue: {},
        }, data);
    }

    setValue = action((value) => {
        value = { ...DEFAULT_VALUES, ...value };
        const items = value.matchCountries?.items || [];
        this.originalValue = {
            matchAllCountries: value.matchAllCountries,
            matchCountries: { items },
        };
        this.matchAllCountries.setValue(value.matchAllCountries);
        this.sourceCountriesSelect.setSelectedValues([...items]);
    });

    isEmpty = () => !this.matchAllCountries.getValue() && this.sourceCountriesSelect.selectedValues.length === 0;

    getValue = () => ({
        matchAllCountries: this.matchAllCountries.getValue(),
        matchCountries: { items: this.sourceCountriesSelect.selectedValues },
    });

    clear = () => {
        this.matchAllCountries.setValue(DEFAULT_VALUES.matchAllCountries);
        this.sourceCountriesSelect.setSelectedValues(DEFAULT_VALUES.matchCountries.items);
    }

    hasChanged = () => {
        const cur = this.getValue();
        return cur.matchAllCountries !== this.originalValue.matchAllCountries ||
            FuseSelectStore.haveDifferentFlatItems(this.originalValue.matchCountries.items, cur.matchCountries.items);
    }
}
